<template>
<div>
	<v-card flat max-width="950px" class="mx-auto transparent">
        <HeadRoot 
            title="Top 3"
            :length="0"
            btn_txt=""
            btn_to="" />
        
        <v-card outlined class="mt-8 pa-6" v-if="loaded">
                <!-- PROFESSIONS -->
                <template>
                    <div class="title primary--text">MY TOP 3 <span class="accent--text">PROFESSIONS</span></div>
                    <div class="d-flex justify-space-between mt-2 align-center">
                        <div class="d-flex align-center">
                            <v-avatar class="primary white--text mr-2" size="30px"><span>1</span></v-avatar>
                            <div v-if="mytop.professions && mytop.professions.p1">{{mytop.professions.p1}}</div>
                            <div class="grey--text text--darken-1" v-else>- Empty -</div>
                        </div>
                        <v-btn depressed class="ml-4 accent--text" small @click="diagProfessions(1)">
                            <v-icon size="12px">fa-pen</v-icon>
                        </v-btn>
                    </div>

                    <div class="d-flex justify-space-between mt-1 align-center">
                        <div class="d-flex align-center">
                            <v-avatar class="primary white--text mr-2" size="30px"><span>2</span></v-avatar>
                            <div v-if="mytop.professions && mytop.professions.p2">{{mytop.professions.p2}}</div>
                            <div class="grey--text text--darken-1" v-else>- Empty -</div>
                        </div>
                        <v-btn depressed class="ml-4 accent--text" small @click="diagProfessions(2)">
                            <v-icon size="12px">fa-pen</v-icon>
                        </v-btn>
                    </div>

                    <div class="d-flex justify-space-between mt-1 align-center">
                        <div class="d-flex align-center">
                            <v-avatar class="primary white--text mr-2" size="30px"><span>3</span></v-avatar>
                            <div v-if="mytop.professions && mytop.professions.p3">{{mytop.professions.p3}}</div>
                            <div class="grey--text text--darken-1" v-else>- Empty -</div>
                        </div>
                        <v-btn depressed class="ml-4 accent--text" small @click="diagProfessions(3)">
                            <v-icon size="12px">fa-pen</v-icon>
                        </v-btn>
                    </div>
                </template>

                <v-divider class="my-8"></v-divider>

                <!-- MAJORS -->
                <template>
                    <div class="title primary--text">MY TOP 3 <span class="accent--text">MAJORS</span></div>
                    <div class="d-flex justify-space-between mt-2 align-center">
                        <div class="d-flex align-center">
                            <v-avatar class="primary white--text mr-2" size="30px"><span>1</span></v-avatar>
                            <div v-if="mytop.majors && mytop.majors.p1">{{mytop.majors.p1}}</div>
                            <div class="grey--text text--darken-1" v-else>- Empty -</div>
                        </div>
                        <v-btn depressed class="ml-4 accent--text" small @click="diagMajors(1)">
                            <v-icon size="12px">fa-pen</v-icon>
                        </v-btn>
                    </div>

                    <div class="d-flex justify-space-between mt-1 align-center">
                        <div class="d-flex align-center">
                            <v-avatar class="primary white--text mr-2" size="30px"><span>2</span></v-avatar>
                            <div v-if="mytop.majors && mytop.majors.p2">{{mytop.majors.p2}}</div>
                            <div class="grey--text text--darken-1" v-else>- Empty -</div>
                        </div>
                        <v-btn depressed class="ml-4 accent--text" small @click="diagMajors(2)">
                            <v-icon size="12px">fa-pen</v-icon>
                        </v-btn>
                    </div>

                    <div class="d-flex justify-space-between mt-1 align-center">
                        <div class="d-flex align-center">
                            <v-avatar class="primary white--text mr-2" size="30px"><span>3</span></v-avatar>
                            <div v-if="mytop.majors && mytop.majors.p3">{{mytop.majors.p3}}</div>
                            <div class="grey--text text--darken-1" v-else>- Empty -</div>
                        </div>
                        <v-btn depressed class="ml-4 accent--text" small @click="diagMajors(3)">
                            <v-icon size="12px">fa-pen</v-icon>
                        </v-btn>
                    </div>
                </template>

                <v-divider class="my-8"></v-divider>

                <!-- UNIVERSITIES -->
                <template>
                    <div class="title primary--text">MY TOP 3 <span class="accent--text">UNIVERSITIES</span></div>
                    <div class="d-flex justify-space-between mt-2 align-center">
                        <div class="d-flex align-center">
                            <v-avatar class="primary white--text mr-2" size="30px"><span>1</span></v-avatar>
                            <div v-if="mytop.universities && mytop.universities.p1">
                                <span v-if="mytop.universities.p1.id!='text'" @click="$router.push('/map-of-careers/best-universities/'+mytop.universities.p1.id)" style="cursor:pointer; text-decoration:underline">
                                    {{mytop.universities.p1.name}}
                                </span>
                                <span v-else>{{mytop.universities.p1.name}}</span>
                            </div>
                            <div class="grey--text text--darken-1" v-else>- Empty -</div>
                        </div>
                        <v-btn depressed class="ml-4 accent--text" small @click="diagUniversities(1)">
                            <v-icon size="12px">fa-pen</v-icon>
                        </v-btn>
                    </div>

                    <div class="d-flex justify-space-between mt-1 align-center">
                        <div class="d-flex align-center">
                            <v-avatar class="primary white--text mr-2" size="30px"><span>2</span></v-avatar>
                            <div v-if="mytop.universities && mytop.universities.p2">
                                <span v-if="mytop.universities.p2.id!='text'" @click="$router.push('/map-of-careers/best-universities/'+mytop.universities.p2.id)" style="cursor:pointer; text-decoration:underline">
                                    {{mytop.universities.p2.name}}
                                </span>
                                <span v-else>{{mytop.universities.p2.name}}</span>
                            </div>
                            <div class="grey--text text--darken-1" v-else>- Empty -</div>
                        </div>
                        <v-btn depressed class="ml-4 accent--text" small @click="diagUniversities(2)">
                            <v-icon size="12px">fa-pen</v-icon>
                        </v-btn>
                    </div>

                    <div class="d-flex justify-space-between mt-1 align-center">
                        <div class="d-flex align-center">
                            <v-avatar class="primary white--text mr-2" size="30px"><span>3</span></v-avatar>
                            <div v-if="mytop.universities && mytop.universities.p3">
                                <span v-if="mytop.universities.p3.id!='text'" @click="$router.push('/map-of-careers/best-universities/'+mytop.universities.p3.id)" style="cursor:pointer; text-decoration:underline">
                                    {{mytop.universities.p3.name}}
                                </span>
                                <span v-else>{{mytop.universities.p3.name}}</span>
                            </div>
                            <div class="grey--text text--darken-1" v-else>- Empty -</div>
                        </div>
                        <v-btn depressed class="ml-4 accent--text" small @click="diagUniversities(3)">
                            <v-icon size="12px">fa-pen</v-icon>
                        </v-btn>
                    </div>
                </template>

                <v-divider class="my-8"></v-divider>

                <!-- COMPANIES -->
                <template>
                    <div class="title primary--text">MY TOP 3 <span class="accent--text">COMPANIES</span></div>
                    <div class="d-flex justify-space-between mt-2 align-center">
                        <div class="d-flex align-center">
                            <v-avatar class="primary white--text mr-2" size="30px"><span>1</span></v-avatar>
                            <div v-if="mytop.companies && mytop.companies.p1">{{mytop.companies.p1}}</div>
                            <div class="grey--text text--darken-1" v-else>- Empty -</div>
                        </div>
                        <v-btn depressed class="ml-4 accent--text" small @click="diagCompanies(1)">
                            <v-icon size="12px">fa-pen</v-icon>
                        </v-btn>
                    </div>

                    <div class="d-flex justify-space-between mt-1 align-center">
                        <div class="d-flex align-center">
                            <v-avatar class="primary white--text mr-2" size="30px"><span>2</span></v-avatar>
                            <div v-if="mytop.companies && mytop.companies.p2">{{mytop.companies.p2}}</div>
                            <div class="grey--text text--darken-1" v-else>- Empty -</div>
                        </div>
                        <v-btn depressed class="ml-4 accent--text" small @click="diagCompanies(2)">
                            <v-icon size="12px">fa-pen</v-icon>
                        </v-btn>
                    </div>

                    <div class="d-flex justify-space-between mt-1 align-center">
                        <div class="d-flex align-center">
                            <v-avatar class="primary white--text mr-2" size="30px"><span>3</span></v-avatar>
                            <div v-if="mytop.companies && mytop.companies.p3">{{mytop.companies.p3}}</div>
                            <div class="grey--text text--darken-1" v-else>- Empty -</div>
                        </div>
                        <v-btn depressed class="ml-4 accent--text" small @click="diagCompanies(3)">
                            <v-icon size="12px">fa-pen</v-icon>
                        </v-btn>
                    </div>
                </template>
        </v-card>

        <SendingLoader v-if="!loaded"/>
	</v-card>

    <DiagMajors 
        v-if="num!=null"
        :model="showDiagMajors" 
        :position="num"
        @cancel="closeDiags"
        @changed="saved" />
    
    <DiagCompanies
        v-if="num!=null"
        :model="showDiagCompanies" 
        :position="num"
        @cancel="closeDiags"
        @changed="saved" />
    
    <DiagProfessions
        v-if="num!=null"
        :model="showDiagProfessions" 
        :position="num"
        @cancel="closeDiags"
        @changed="saved" />
    
    <DiagUniversities
        v-if="num!=null"
        :model="showDiagUniversities" 
        :position="num"
        @cancel="closeDiags"
        @changed="saved" />
</div>
</template>

<script>
import _ from 'lodash'
import Sign from '@/firebase/sign'
import DiagMajors from '@/components/core/dialogs/DiagMajors'
import DiagCompanies from '@/components/core/dialogs/DiagCompanies'
import DiagProfessions from '@/components/core/dialogs/DiagProfessions'
import DiagUniversities from '@/components/core/dialogs/DiagUniversities'

export default {
    data: () => ({
        loaded: true,
        showDiagMajors: false,
        showDiagCompanies: false,
        showDiagProfessions: false,
        showDiagUniversities: false,
        num: null,
        mytop: {
            professions: {
                p1: '', p2: '', p3: ''
            },
            majors: {
                p1: '', p2: '', p3: ''
            },
            universities: {
                p1: '', p2: '', p3: ''
            },
            companies: {
                p1: '', p2: '', p3: ''
            }
        }
    }),
    components: {
        DiagMajors,
        DiagCompanies,
        DiagProfessions,
        DiagUniversities
    },
    mounted() {
        this.init();
    },
    methods: {
        clear() {
            this.mytop = {
                professions: {
                    p1: '', p2: '', p3: ''
                },
                majors: {
                    p1: '', p2: '', p3: ''
                },
                universities: {
                    p1: '', p2: '', p3: ''
                },
                companies: {
                    p1: '', p2: '', p3: ''
                }
            }
        },
        init() {
            if (this.user.mytop) {
                this.mytop = _.merge(this.mytop, this.user.mytop)
            }
            this.loaded = true;
        },
        diagMajors(num) {
            this.num = num;
            this.showDiagMajors = true;
        },
        diagCompanies(num) {
            this.num = num;
            this.showDiagCompanies = true;
        },
        diagProfessions(num) {
            this.num = num;
            this.showDiagProfessions = true;
        },
        diagUniversities(num) {
            this.num = num;
            this.showDiagUniversities = true;
        },
        closeDiags() {
            this.showDiagMajors = false;
            this.showDiagCompanies = false;
            this.showDiagProfessions = false;
            this.showDiagUniversities = false;
        },
        saved(e) {
            Sign.reInitUser(this.user.uid);
            this.closeDiags();
            this.clear();
            this.mytop = _.merge(this.mytop, e)
        }
    }
}
</script>
